<template>
	<div class="editInput">
		<div v-if="!show">
			<el-input-number
				v-if="tableData.number"
				v-model="value"
				style="width: 80%"
				v-bind="tableData"
				@blur="blur"
				@change="InputChange"
				:size="size"
				:precision="2"
				:step="0.1"
			></el-input-number>
			<el-input
				:size="size"
				v-model="value"
				v-else
				@blur="blur"
				@change="InputChange"
				style="width: 100%"
			>
			</el-input>
		</div>
		<div v-if="show">
			{{ scope.row[tableData.bind] }}
			<ig-icon name="bianji" class="bianji-icon" @click="change"></ig-icon>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editInput',
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		let that = this;
		return {
			value: that.scope.row[that.tableData.bind],
			show: true,
		};
	},
	computed: {
		size() {
			return this.tableData.size || 'mini';
		},
	},
	watch: {
		'scope.row': {
			handler() {
				this.show = true;
				this.value = this.scope.row[this.tableData.bind];
			},
			deep: true,
			immediate: true,
		},
	},

	methods: {
		change() {
			this.show = !this.show;
		},
		blur() {
			this.show = !this.show;
		},
		InputChange(val) {
			let { scope, tableData } = this;
			this.value = this.scope.row[this.tableData.bind];
			tableData.change && tableData.change(val, scope, tableData);
		},
	},
};
</script>

<style lang="scss" scoped>
.editInput {
	display: flex;
	.bianji-icon {
		margin-left: 10px;
		cursor: pointer;
	}
}
</style>
